"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Overlay = _interopRequireDefault(require("ol/Overlay"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FeaturePropertiesPopup = function FeaturePropertiesPopup(_ref) {
  var map = _ref.map;
  var popupRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      popup = _useState2[0],
      setPopup = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      features = _useState6[0],
      setFeatures = _useState6[1];
  /**
   * Event handler fired once the mouse is clicked in the map. 
   * This handler will show a popup  if the
   * mouse is clicked over a feature.
   */


  var onClickFeatureOnMap = (0, _react.useCallback)(function (evt) {
    var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
      return feature;
    });

    if (feature) {
      popup.setPosition(evt.coordinate);
      setVisible(true);
      setFeatures([feature]); // popupRef.current.popover({
      //     placement: 'top',
      //     html: true,
      //     content: feature.get('display_name'),
      // });
      // popupRef.current.popover('show');
    } else {
      //popupRef.current.popover('dispose');
      setVisible(false);
    }
  }, [map, popup]);
  /**
   * Event handler fired once the mouse pointer is 
   * moved on the map.
   * This handler will change the pointer if the
   * mouse is over a feature.
   */

  var onPointerMoveOnMap = (0, _react.useCallback)(function (evt) {
    var pixel = map.getEventPixel(evt.originalEvent);
    var hit = map.hasFeatureAtPixel(pixel);
    map.getTarget().style.cursor = hit ? 'pointer' : '';
  }, [map]);
  /**
   * Event handler fired once the map is moved.
   * This handler will dispose the popup.
   */

  var onMoveStartOnMap = (0, _react.useCallback)(function (evt) {
    //popupRef.current.popover('dispose');
    setVisible(false);
  }, []);
  /**
   * Effect to add overlay in the map
   */

  (0, _react.useEffect)(function () {
    var overlay = null;

    if (popupRef.current && !popup) {
      overlay = new _Overlay.default({
        element: popupRef.current,
        positioning: 'bottom-center',
        stopEvent: false
      });
      setPopup(overlay);
      map.addOverlay(overlay);
    }

    return function () {
      map.removeOverlay(popup);
    };
  }, [popup, map]); // useEffect(() => {
  //     if(!popup) {
  //         const overlay = new Overlay({
  //             element: popupRef.current,
  //             positioning: 'bottom-center',
  //             stopEvent: false
  //         });
  //         setPopup(overlay);
  //         map.addOverlay(overlay);
  //     }
  //     return () => {
  //         map.removeOverlay(popup);
  //     }
  // }, [map, popup]);
  // useEffect(() => {
  //     if(popupRef.current && popup && !popup.getElement()) {
  //         popup.setElement(popupRef.current );
  //     }
  // }, [popup]);

  /**
   * Effect to register 'click' event in the map
   */

  (0, _react.useEffect)(function () {
    map.on('click', onClickFeatureOnMap);
    return function () {
      return map.un('click', onClickFeatureOnMap);
    };
  }, [map, onClickFeatureOnMap]);
  /**
   * Effect to register 'pointermove' event in the map
   */

  (0, _react.useEffect)(function () {
    map.on('pointermove', onPointerMoveOnMap);
    return function () {
      return map.un('pointermove', onPointerMoveOnMap);
    };
  }, [map, onPointerMoveOnMap]);
  /**
   * Effect to register 'movestart' event in the map
   */

  (0, _react.useEffect)(function () {
    map.on('movestart', onMoveStartOnMap);
    return function () {
      return map.un('movestart', onMoveStartOnMap);
    };
  }, [map, onMoveStartOnMap]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Popover, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          background: "blue",
          color: "white",
          border: 5
        },
        children: "Properties"
      }),
      trigger: "click",
      placement: "top" //content={features.length > 0 ? <div>{features[0].get('display_name')}</div> : null}
      ,
      content: features.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: JSON.stringify(features[0].getProperties(), null, '\t')
      }) : null,
      visible: visible && features.length > 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: popupRef
      })
    })
  });
};

var _default = FeaturePropertiesPopup;
exports.default = _default;